import { TableNavigationModel } from "@app/shared/models/table-navigation.model";
import * as _ from "lodash";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { SearchFilterModel } from "../models/search-filter.model";
import { ReferentialItem } from "../models/shared/referential-item.model";
import { AssetService } from "./asset.service";
import { CommonService } from "./common.service";
import { RecipientEntitiesService } from "./recipient-entities.service";
import { SessionStorageService } from "./session-storage.service";

export abstract class SearchService<TSearchModel> extends CommonService {

    public searchCriteriaModel: TSearchModel;

    public assetsDropdownList: ReferentialItem[] = [];
    public assetsSelectedItems: ReferentialItem[] = [];

    public recipientEntitiesDropdownList: ReferentialItem[] = [];
    public recipientEntitiesSelectedItems: ReferentialItem[] = [];

    public exportFileName: string;
    public pageIndex: number = 0; dropdownSettings: IDropdownSettings = {};
    public panelOpenState: boolean;
    public sortColumn: string = '';
    public sortDirection: string = '';
    public pageSize: number = 20;
    public paginatorLength: number = 10;

    protected areAllRecipientEntitiesSelected: boolean = false;
    protected areAllAssetsSelected: boolean = false;
    protected areAssetsInit: boolean = false;
    protected areRecipientEntitiesInit: boolean = false;

    protected filterStorageKey: string;
    protected tableConfig: string;

    constructor(protected sessionStorageService: SessionStorageService,
        protected assetService: AssetService,
        protected recipientEntitiesService: RecipientEntitiesService) {
        super(assetService, recipientEntitiesService);
    }

    protected onAssetFetched(assets: ReferentialItem[]) {
        this.assetsDropdownList = assets;
        if (!this.areAssetsInit) {
            this.areAssetsInit = true;
            if (this.areRecipientEntitiesInit) {
                this.restoreFilters();
            }
        }
    }
    protected onRecipientEntitiesFetched(recipientEntities: ReferentialItem[]) {
        this.recipientEntitiesDropdownList = recipientEntities;
        if (!this.areRecipientEntitiesInit) {
            this.areRecipientEntitiesInit = true;
            if (this.areAssetsInit) {
                this.restoreFilters();
            }
        }
    }

    protected restoreServerSideRecipientEntities(recipientEntities: ReferentialItem[]): void {
        const itemsNotInCurrentList = recipientEntities.filter(r => !this.recipientEntitiesDropdownList.map(rd => rd.Id).includes(r.Id));
        this.recipientEntitiesDropdownList.push(...itemsNotInCurrentList);
        this.recipientEntitiesSelectedItems = recipientEntities;
    }

    protected restoreServerSideAssets(assets: ReferentialItem[]): void {
        const itemsNotInCurrentList = assets.filter(r => !this.assetsDropdownList.map(rd => rd.Id).includes(r.Id));
        this.assetsDropdownList.push(...itemsNotInCurrentList);
        this.assetsSelectedItems = assets;
    }

    protected restoreFilters() {
        const searchFilter = this.sessionStorageService.get<SearchFilterModel<TSearchModel>>(this.filterStorageKey);
        const pageNavigation = Object.assign({}, JSON.parse(localStorage.getItem(this.tableConfig))?.pageDef) as TableNavigationModel;

        if (!_.isNil(pageNavigation.Sort)) {
            this.sortColumn = pageNavigation.Sort.active;
            this.sortDirection = pageNavigation.Sort.direction;
        }

        if (!_.isNil(pageNavigation.Page)) {
            this.pageSize = pageNavigation.Page.pageSize;
        }

        if (_.isNil(searchFilter)) {
            return;
        }

        this.searchCriteriaModel = searchFilter.Filter;
        this.pageIndex = searchFilter.Page;

        this.restoreFiltersInner(searchFilter);
        this.restoreServerSideDropdownLists(searchFilter.ExtraFilters);
    }

    protected restoreServerSideDropdownLists(filters: any): void {
        if (_.isNil(filters)) {
            return;
        }

        const filterHasRecipientEntities = Array.isArray(filters.RecipientEntities)
            && filters.RecipientEntities.length > 0;
        if (filterHasRecipientEntities) {
            this.restoreServerSideRecipientEntities(filters.RecipientEntities);
        }

        const filterHasAssets = Array.isArray(filters.Assets)
            && filters.Assets.length > 0;
        if (filterHasAssets) {
            this.restoreServerSideAssets(filters.Assets);
        }
    }

    protected storeFilters(): void {
        var filter = new SearchFilterModel();
        filter.Filter = this.searchCriteriaModel;
        filter.Page = this.pageIndex;
        filter.ExtraFilters = {
            RecipientEntities: this.recipientEntitiesSelectedItems,
            Assets: this.assetsSelectedItems,
        }
        sessionStorage.setItem(this.filterStorageKey, JSON.stringify(filter));
    }

    protected abstract restoreFiltersInner(searchFilter: SearchFilterModel<TSearchModel>): void;
}